import { useState } from "react";
import MessageContainer from "./MessageContainer";
import MessageFooter from "./MessageFooter";

export default function VideoMessage({ message }) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const { content, direction, status, createdAt } = message;
  const isOutbound = direction === "OUTBOUND";

  const videoUrl = content.media?.link;
  const caption = content.media?.caption;

  if (!videoUrl) {
    return null;
  }

  return (
    <MessageContainer isOutbound={isOutbound} className="p-0 overflow-hidden">
      <div className="relative">
        {isLoading && (
          <div className="w-48 h-48 bg-gray-200 dark:bg-slate-700 flex items-center justify-center">
            <span className="text-xs text-gray-500">Loading...</span>
          </div>
        )}
        {!hasError ? (
          <video
            controls
            className="w-48 h-auto rounded-lg"
            onLoadedMetadata={() => setIsLoading(false)}
            onError={() => {
              setIsLoading(false);
              setHasError(true);
            }}
          >
            <source src={videoUrl} type="video/mp4" />
            <source src={videoUrl} type="video/webm" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <div className="w-48 h-48 bg-gray-200 dark:bg-slate-700 flex items-center justify-center">
            <span className="text-xs text-gray-500">Failed to load video</span>
          </div>
        )}
        {caption && (
          <div className="p-2 bg-gray-100 dark:bg-slate-700 text-sm break-words">
            {caption}
          </div>
        )}
      </div>
      <MessageFooter status={status} timestamp={createdAt} isOutbound={isOutbound} className="px-2 pb-2" />
    </MessageContainer>
  );
}
